import { useMutation, useQueryClient } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

export const useAcceptTerms = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => await edupassClient.post('/accept_terms', {}),
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [clientKeys.useUser] });
    },
  });
};
